// GENERATED CODE -- DO NOT EDIT!
// To re-generate this file:
// start local dev server (w/ backend turned on)
// go run ./services/rewards/cmd/generate-translations
import memoize from "lodash.memoize";

import type {BadgeInfo} from "../badge-translations.ts";

export const getCustomBadges: () => Record<string, BadgeInfo> = memoize(
    (): Record<string, BadgeInfo> => ({}),
);
